export default {"src":"/_next/static/media/go-login.28afec31.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};